module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/luna/luna_vis-c25fe2bad2fc66bfbbd8793f9f3cdda5.jpg";